import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import {withRouter} from "react-router-dom";

import Button from "@mui/material/Button";
import FormGroup from '@mui/material/FormGroup';

import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {ROUTES} from "../../../../../routes";
import GroheCartHeaderCommon from "../groheCartHeaderCommon";
import LookUserPhoneInput from "../../../user/lookUserPhoneInput";
import LookUserInput from "../../../user/lookUserInput";
import store from "../../../../../store";
import WithInputValidations from "../../../hocs/withInputValidations";
import GroheCartStickyFooter from "../groheCartStickyFooter";

const GroheCartTwoFA = (props) => {

  const {history, isMobile} = props;

  const nextButtonClick = async (updateInputValidations) => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.cartTwoFANext);
    await updateInputValidations();
    const errors = store.getState().userState.userInfoErrors;
    if (Object.keys(errors).length && Object.keys(errors)
      .filter(key => key === "phoneNumber")
      .some(key => errors[key] && errors[key].length)) {
      return false
    }
    history.push(ROUTES.cartTwoFAVerify);
  };

  return (
    <WithInputValidations>
      {(inputsValidated, updateInputValidations) => {
        const stickyFooterButtons = [
          {
            translate: "buttons.back",
            classes: "look-button--secondary",
            onClick: () => {
              history.push(ROUTES.cart);
            }
          },
          {
            translate: "buttons.accept",
            classes: "look-button--blue",
            onClick: () => nextButtonClick(updateInputValidations)
          }
        ];
        return (
          <div className="gc">
            <div className="gc-body">
              <GroheCartHeaderCommon title="grohe.cart.twoFA.title" subTitle="grohe.cart.twoFA.subTitle"/>
              <FormGroup className="gc-form">
                <div className="gc-form__center">
                  <div className="gc-form__inputs-block">
                    <LookUserPhoneInput property={"phoneNumber"} inputsValidated={inputsValidated} />
                  </div>
                  <div className="gc-form__inputs-block gc-form__inputs-block--hidden">
                    <LookUserInput property={"hidden"} inputsValidated={true} /> {/*this input is needed here for Material UI to add its styles! */}
                  </div>
                </div>
                {isMobile ? null : (
                  <div className="gc-form__submit">
                    <div className="gc-form__submit-left"/>
                    <div className="gc-form__submit-right">
                      <Button className="look-button look-button--blue look-button--big look-button--large nowrap"
                        // disabled={loaderOpened}
                              onClick={() => nextButtonClick(updateInputValidations)}>
                        <FormattedMessage id="buttons.next"/>
                      </Button>
                    </div>
                  </div>
                )}
              </FormGroup>
              {isMobile ? <div className="gc-spacer"/> : null}
            </div>
            {isMobile ? <GroheCartStickyFooter stickyFooterButtons={stickyFooterButtons}/> : null}
          </div>
        )
      }}
    </WithInputValidations>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  return {
    isMobile,
  };
};

export default withRouter(
  connect(mapStateToProps)(GroheCartTwoFA)
)
